import { render, staticRenderFns } from "./Legislativo.vue?vue&type=template&id=720683ce&scoped=true"
import script from "./Legislativo.vue?vue&type=script&lang=js"
export * from "./Legislativo.vue?vue&type=script&lang=js"
import style0 from "./Legislativo.vue?vue&type=style&index=0&id=720683ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720683ce",
  null
  
)

export default component.exports